module.exports = __webpack_public_path__ + "static/media/mazaZolePlayed_50000_100000.cccf44b9.png";